import { filterSelectableDimensions } from "../../../Models/SelectableDimensions/SelectableDimensions";
import Box from "../../../Styled/Box";
import SelectableDimensionComponent from "../../SelectableDimensions/SelectableDimension";
import { jsx as _jsx } from "react/jsx-runtime";
const GeneratedControlSection = _ref => {
  let {
    item,
    controls,
    placement
  } = _ref;
  const enabledDimensions = filterSelectableDimensions(placement)(controls);
  if (enabledDimensions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    displayInlineBlock: true,
    fullWidth: true,
    children: enabledDimensions.map((dim, _i) => /*#__PURE__*/_jsx(SelectableDimensionComponent, {
      id: "".concat(item.uniqueId, "-generated-control-").concat(dim.id),
      dim: dim
    }, "".concat(item.uniqueId, "-generated-control-").concat(dim.id, "-fragment")))
  });
};
export default GeneratedControlSection;